import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiErr } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchMe = useCallback(async () => {
        const token = localStorage.getItem("jm_token");
        if (!token) { setUser(null); setLoading(false); return; }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem("jm_token");
            setUser(null);
        } finally { setLoading(false); }
    }, []);

    useEffect(() => { fetchMe(); }, [fetchMe]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("jm_token", data.token);
            setUser(data.user);
            return { ok: true };
        } catch (e) { return { ok: false, error: apiErr(e, "No se pudo iniciar sesión") }; }
    };

    const register = async (email, password, name) => {
        try {
            const { data } = await api.post("/auth/register", { email, password, name });
            localStorage.setItem("jm_token", data.token);
            setUser(data.user);
            return { ok: true };
        } catch (e) { return { ok: false, error: apiErr(e, "No se pudo registrar") }; }
    };

    const logout = () => { localStorage.removeItem("jm_token"); setUser(null); };

    return <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh: fetchMe }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
